<template>
  <div :id="id" :class="[wrapperClasses, heroHeaderImageFocalPoint]">
    <div class="flex w-full flex-col items-center py-8 xl:container lg:mx-auto lg:flex-row">
      <div class="w-full px-5 pt-6 lg:w-1/2 lg:pt-0 xl:w-2/5">
        <div class="mb-8 text-3xl font-bold lg:text-5xl" v-html-safe="heroTitle"></div>
        <div class="w-full sm:w-3/4">
          <div class="mb-8 text-lg leading-9" v-html-safe="heroSubtitle"></div>
          <div class="hero-ups mb-8 flex flex-col">
            <template v-for="(usp, index) in heroUsps" :key="index">
              <div class="flex items-center font-bold">
                {{ usp.heroUsp }}
              </div>
            </template>
          </div>
          <SignInForm v-if="showLoginHero && !isAuthenticated" grow-buttons @succeeded="onSignIn" />
        </div>
      </div>
      <div class="flex w-full lg:w-1/2 lg:justify-end xl:w-3/5">
        <VcImage :src="heroHeaderImage" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SignInForm, useUser } from "@/shared/account";

type HeroUspsType = {
  heroUsp: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  showLoginHero?: boolean;
  heroTitle?: string;
  heroSubtitle?: string;
  heroHeaderImage?: string;
  heroHeaderImageFocalPoint?: string;
  heroUsps?: Array<HeroUspsType>;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.heroHeaderImageFocalPoint ? props.heroHeaderImageFocalPoint : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)]",
    "banner flex items-center",
  ];
});

const { isAuthenticated } = useUser();

function onSignIn() {
  location.href = "/account/profile";
}
</script>

<style scoped>
.banner {
  min-height: 700px;
}
.hero-ups div:before {
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  margin: 0 1rem;
  background-color: var(--color-secondary);
}
</style>
